// src/reducers/userReducer.js
const initialState = {
    user: JSON.parse(sessionStorage.getItem("user")) || null, // load from session if available
};
  
export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_USER":
            sessionStorage.setItem("user", JSON.stringify(action.payload));
            return { ...state, user: action.payload };
    
        case "UPDATE_USER":
            const updatedUser = { ...state.user, ...action.payload };
            sessionStorage.setItem("user", JSON.stringify(updatedUser));
            return { ...state, user: updatedUser };
    
        case "CLEAR_USER":
            sessionStorage.removeItem("user");
            return { ...state, user: null };
    
        default:
            return state;
    }
  };
  